<p class="laft-form--title">Documento de identidad</p>
<form class="laft-form" [formGroup]="idCopiesForm">
  <section class="laft-form--group">
    <p class="laft-form--group-title">Adjunta una foto de tu documento de identidad: {{ declaredDocument }}</p>
    <span class="laft-form--upload-hint"
      >Solo se aceptan archivos en formato jpg, jpeg y png que no sean mayores a 5MB.</span
    >
    <div class="laft-form--uploads" [class.laft-form--uploads-single]="isSingleSided">
      <app-upload
        formControlName="idFrontPicture"
        accepts="image"
        (onFileLoaded)="onFrontPictureLoaded($event)"
        [initialLabel]="isSingleSided ? 'Subir documento' : 'Parte frontal'"
        [loadedLabel]="isSingleSided ? 'Documento cargado' : 'Parte frontal cargada'"
      ></app-upload>
      <app-upload
        *ngIf="!isSingleSided"
        formControlName="idBackPicture"
        accepts="image"
        [default]="initData?.idBackPicture"
        initialLabel="Parte posterior"
        loadedLabel="Parte posterior cargada"
      ></app-upload>
    </div>
    <div class="laft-form--upload-feedback" *ngIf="isValidatingIdCopy || idCopyError">
      <p class="laft-form--upload-checking" *ngIf="isValidatingIdCopy">
        <span class="laft-form--spinner"></span>
        Estamos validando tu documento de identidad...
      </p>
      <app-section-message *ngIf="idCopyError" [text]="idCopyError" type="warning"></app-section-message>
    </div>
  </section>
  <app-section-message [text]="consents.DECLARATION_NOTICE" type="informative"></app-section-message>
  <section class="laft-form--checkbox">
    <app-checkbox [content]="consents.CONTRACT" formControlName="acceptsContract" errorMessage="Requerido"></app-checkbox>
    <app-checkbox [content]="consents.COMMERCIAL_USE" formControlName="acceptsCommercialUse"></app-checkbox>
  </section>
  <div class="laft-form--actions">
    <button class="laft-form--btn-submit" type="button" (click)="onContinue()" [disabled]="!canSubmit">
      {{ isValidatingIdCopy ? 'Validando documento...' : 'Enviar información' }}
    </button>
  </div>
</form>
